function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "confirm-order_svg__a",
  x1: "50.147%",
  x2: "50.147%",
  y1: "100.155%",
  y2: "-.25%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "26%",
  stopColor: "#F69321"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "74%",
  stopColor: "#EF7700"
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.814 0c.716 0 1.38.362 1.79.932l2.198 3.106v.025l.007.007.019.02c.025.05.05.077.076.129 0 .026.026.026.026.051.025.052.025.104.05.181.026.078.026.13 0 .182v15.245c0 1.164-.945 2.122-2.095 2.122H2.096C.946 22 0 21.042 0 19.878V4.45c0-.077.025-.13.051-.18 0-.026.025-.026.025-.052.026-.052.052-.078.077-.13l.026-.026v-.025L2.377.932C2.812.362 3.477 0 4.192 0zM4.46 16.494H2.614c-.34 0-.615.279-.615.623s.275.623.615.623H4.46a.62.62 0 00.616-.623.62.62 0 00-.616-.623zM6.306 14H2.614a.62.62 0 00-.615.623c0 .344.275.623.615.623h3.692c.34 0 .616-.279.616-.623S6.646 14 6.306 14zm6.987-9.07H9.714v2.727l1.79-.983 1.79.983V4.932zm5.521-2.861h-4.167l.435 1.553h4.934l-1.048-1.475c-.051-.052-.103-.078-.154-.078zm-6.288 0H10.48l-.435 1.553h2.914l-.434-1.553zm-4.167 0H4.193c-.077 0-.128.026-.153.077L3.017 3.623h4.908l.434-1.553z",
  fill: "url(#confirm-order_svg__a)",
  fillRule: "nonzero"
});

function SvgConfirmOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22
  }, props), _ref, _ref2);
}

export default SvgConfirmOrder;